import React from 'react'

const AcceptedOrderSupplierPeykContainer = () => {
  return (
    <div>AcceptedOrderSupplierPeykContainer</div>
  )
}

export default AcceptedOrderSupplierPeykContainer